// extracted by mini-css-extract-plugin
export default {"container":"style_container__C-ILU","card":"style_card__u-l7r"};